function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS FilterSingle INSTEAD.
import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@unite-us/ui';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import browser from "../../utils/browser";
import { createFilterId } from "../Filter/utils";
import { findFirstOption, formatDropdownOptions } from "./utils";
import FilterOption from "./components/FilterOption";

/**
 * @visibleName FilterSingle DEPRECATED
*/

var FilterSingle = function FilterSingle(_ref) {
  var className = _ref.className,
    name = _ref.name,
    uniqIdPrefix = _ref.uniqIdPrefix,
    onFilterChange = _ref.onFilterChange,
    initialOptions = _ref.options,
    initialValue = _ref.value,
    dataTestId = _ref.dataTestId,
    prefixLabel = _ref.prefixLabel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var options = formatDropdownOptions(initialOptions);
  var _useState3 = useState(initialValue),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var filterWrapperRef = useRef(null);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    optionChanged = _useState6[0],
    setOptionChanged = _useState6[1];
  useEffect(function () {
    var onClickOutside = function onClickOutside(e) {
      if (open) {
        var path = browser.getEventPath(e);
        var index = _.findIndex(path, filterWrapperRef.current);
        if (index < 0) {
          setOpen(false);
        }
      }
    };
    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [open]);
  useEffect(function () {
    if (!_.isEqual(initialValue, value)) {
      setValue(initialValue);
    }
  }, [initialValue, value]);
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    setOpen(!open);
  };
  var onOptionChange = function onOptionChange(selectedFilter, newValue) {
    onFilterChange(selectedFilter, newValue);
    setValue(newValue);
    setOpen(false);
    setOptionChanged(true);
  };
  var activeFilter = _.find(options, {
    value: value
  }) || findFirstOption(options);
  var optionElements = _.map(options, function (option) {
    return /*#__PURE__*/React.createElement(FilterOption, {
      id: "".concat(uniqIdPrefix).concat(name, "-").concat(option.value),
      isActive: activeFilter.value === option.value,
      key: "".concat(name, "-").concat(option.value),
      name: name,
      onChange: onOptionChange,
      option: option
    });
  });
  var currentFilter = _.find(options, {
    value: value
  }) || findFirstOption(options);
  var filterClass = classNames({
    'max-w-350px min-w-250px relative': true
  }, className);
  var filterButtonClass = classNames('font-regular text-sm block min-h-2.25rem px-2.125 pl-2.5 py-0 relative text-left select-none w-full border border-solid', {
    'rounded-t border border-united-blue overflow-hidden': open
  }, {
    rounded: !open
  }, {
    'bg-light-border-blue hover:bg-dark-fill-blue border-filter-border-color': !open && optionChanged
  }, {
    'hover:bg-medium-fill-grey bg-white border-light-border-blue': !open && !optionChanged
  });
  var dropdownClass = classNames('', {
    'block bg-white absolute from-white to-light-border-grey rounded-b border border-t-0 border-solid border-united-blue z-dropdown overflow-hidden left-0 right-0 top full': open
  }, {
    'hidden border-light-border-blue left-0 right-0 top-full border-t-0 border': !open
  });
  var checkIconClass = classNames({
    'inline-block mr-2': true
  }, {
    hidden: !optionChanged
  });
  var accessibilityLabel = "".concat(currentFilter.label, " selected, dropdown");
  var label = prefixLabel ? "".concat(prefixLabel).concat(currentFilter.label) : currentFilter.label;
  return /*#__PURE__*/React.createElement("div", {
    className: filterClass,
    id: createFilterId(name),
    ref: filterWrapperRef
  }, /*#__PURE__*/React.createElement("button", {
    role: "listbox",
    onClick: onButtonClick,
    className: filterButtonClass,
    "aria-label": accessibilityLabel,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement("span", {
    className: checkIconClass
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "mb-1",
    viewBox: "0 0 20 20",
    color: "#2C405A",
    icon: "IconCheck",
    size: 14
  })), label, open ? /*#__PURE__*/React.createElement(Icon, {
    className: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    icon: "IconCaretUp",
    size: 16,
    color: "#333333"
  }) : /*#__PURE__*/React.createElement(Icon, {
    className: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    icon: "IconCaretDown",
    size: 16,
    color: "#67859E"
  })), /*#__PURE__*/React.createElement("div", {
    className: dropdownClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto select-none max-h-450px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ui-filter-options__container"
  }, optionElements))));
};
FilterSingle.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  uniqIdPrefix: PropTypes.string,
  dataTestId: PropTypes.string,
  prefixLabel: PropTypes.string
};
FilterSingle.defaultProps = {
  className: '',
  uniqIdPrefix: '',
  dataTestId: '',
  prefixLabel: ''
};
export default FilterSingle;